document.addEventListener("DOMContentLoaded", () => {
  let featuredArticles = document.querySelectorAll('.wp-block-featured-article');
   if (featuredArticles) {
    let lastFeaturedArticle = [].slice.call(featuredArticles).pop();
    if (lastFeaturedArticle) {
      lastFeaturedArticle.classList.add('wp-block-featured-article--last');
    }
  }
});
